import React from 'react'

import styles from './PropertyList.module.css'

export default function Property({ label, children }) {
  return (
    <div className={styles.property}>
      <h5 className={styles.label}>{label}</h5>
      <div className={styles.value}>{children}</div>
    </div>
  )
}
